import type { Creative } from '../../../server/models/direct-ads'

export const useRandomDirectAdCreative = (creatives: Creative[]): Creative => {
  const randomIndex = Math.floor(Math.random() * creatives.length)

  return creatives[randomIndex]
}
